import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_11: FaireProductEntity = {
  token: "caden-lane-11",
  type: "product",
  name: "CuddleLane™ Luxe Blankets | Solids",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/e251a90e1d82929b0a9e510e66d325712b69d386dd22712d2595ba857b6795f9.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 26,
  msrpDollars: 52,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_home-decor-bedding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
